import { ReactNode } from 'react';

import { usePrefetchBookerCommissions } from '../../hooks/useFetchBookerCommissions';
import { usePrefetchCustomRules } from '../../hooks/useFetchCustomRules';
import { DEFAULT_GET_TRIPS_CONFIG, usePrefetchTripsPage } from '../../hooks/useFetchTrips';
import { usePrefetchUserTrees } from '../../hooks/useFetchUserTrees';

type Props = {
  children: ReactNode;
};

export const InitGate = ({ children }: Props) => {
  usePrefetchUserTrees();
  usePrefetchBookerCommissions();
  usePrefetchCustomRules();
  usePrefetchTripsPage(DEFAULT_GET_TRIPS_CONFIG, 1);

  return <>{children}</>;
};
